import { createQueryKeys } from '@lukemorales/query-key-factory'

import type { UseQueryOptionsWithoutQueryFn } from '~/types/util/tanstack-query'

import { type ParametersGetAll, useFetchWorkspaceUsers } from './useFetchWorkspaceUsers'

export const queryKeys = createQueryKeys('workspace-users', {
  all: ({ workspaceId, params }: { workspaceId: MaybeRef<string>, params?: MaybeRef<ParametersGetAll> }) =>
    ({ queryKey: [workspaceId, params] }),
})

const getAll = ({
  params,
  useQueryOptions = {},
}: {
  params?: MaybeRef<ParametersGetAll>
  useQueryOptions?: UseQueryOptionsWithoutQueryFn
}) => {
  const { getAll } = useFetchWorkspaceUsers()
  const { activeWorkspaceId } = useAuth()

  return useQuery({
    ...queryKeys.all({
      workspaceId: activeWorkspaceId as MaybeRef<string>,
      params,
    }),
    queryFn: () => getAll({
      workspaceId: unref(activeWorkspaceId) || '',
      params: unref(params),
    }),
    enabled: () => !!unref(activeWorkspaceId),
    ...useQueryOptions,
  })
}

export const useQueryWorkspaceUsers = {
  getAll,
}
